export default __webpack_public_path__ + "static/media/medina-blusa-azul.bf613236.png";